
import {dbaccessApi, adminwebApi, faceDetectApi} from "./axios.js"

// ユーザー情報数取得
const getAxiosUserCount = async() => {
  const response = await dbaccessApi.get("/getallusercount")
  return response.data
}

// ユーザー情報登録
const postAxiosUserRegist = async(data) => {
  const response = await faceDetectApi.post("/detect", data)
  return response.data
}
// 特徴量の取得
const getAxiosFeature= async(data) => {
  const response = await faceDetectApi.post("/extract", data)
  return response.data
}

// ユーザー情報取得
const getAxiosAllUser = async() => {
  const response = await dbaccessApi.get("/getalluserinfo")
  return response.data
}

// ユーザー情報更新
const patchAxiosUpdUser = async(data) => {
  const response = await dbaccessApi.patch("/upduserinfo", data)
  return response.data
}

// ユーザー情報削除
const deleteAxiosUser = async(params) => {
  const response = await dbaccessApi.delete("/deluserinfo", {
    params: params
  })
  return response.data
}

// 顔認証閾値取得
const getAxiosAuthThreshold = async() => {
  const response = await dbaccessApi.get("/getthreshold")
  return response.data
}
// 顔認証閾値設定
const patchAxiosAuthThreshold = async(data) => {
  const response = await dbaccessApi.patch("/setthreshold", data)
  return response.data
}

// 認証情報取得
const getAxiosAuthInfo = async(params) => {
  const response = await adminwebApi.get("/getauthinfo", {
    params: params
  })
  return response.data
}
// 認証ログ取得
const getAxiosAuthLogs = async(params) => {
  const response = await adminwebApi.get("/getauthlog", {
    params: params
  })
  return response.data
}

// 契約プラン取得
const getAxiosContractPlan = async() => {
  const response = await adminwebApi.get("/getcontractplan")
  return response.data
}
export default {
    getAxiosUserCount,
    postAxiosUserRegist,
    getAxiosAllUser,
    getAxiosFeature,
    patchAxiosUpdUser,
    deleteAxiosUser,
    getAxiosAuthInfo,
    getAxiosAuthLogs,
    getAxiosContractPlan,
    getAxiosAuthThreshold,
    patchAxiosAuthThreshold
}